import React from 'react';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-169">
          Se lavori con bambini, probabilmente conosci bene questa situazione.
        </h2>

        <div className="space-y-4 mb-10" data-id="element-170">
          <div className="flex items-start p-6 bg-red-50 border border-red-200 rounded-2xl shadow-sm" data-id="element-171">
            <div className="flex-shrink-0 mt-1" data-id="element-172">
              <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center" data-id="element-173">
                <X className="w-5 h-5 text-red-600" data-id="element-174" />
              </div>
            </div>
            <p className="ml-4 text-lg text-gray-800 font-medium" data-id="element-175">
              I bambini fanno fatica a rimanere concentrati.
            </p>
          </div>

          <div className="flex items-start p-6 bg-red-50 border border-red-200 rounded-2xl shadow-sm" data-id="element-176">
            <div className="flex-shrink-0 mt-1" data-id="element-177">
              <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center" data-id="element-178">
                <X className="w-5 h-5 text-red-600" data-id="element-179" />
              </div>
            </div>
            <p className="ml-4 text-lg text-gray-800 font-medium" data-id="element-180">
              Si agitano facilmente, si distraggono durante le attività e spesso
              è difficile aiutarli a calmarsi.
            </p>
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-md mb-8" data-id="element-181">
          <p className="text-xl text-gray-800 mb-6 font-medium" data-id="element-182">
            Molti genitori e insegnanti cercano attività che possano aiutare i
            bambini a:
          </p>
          <ul className="space-y-3 text-lg text-gray-700 ml-2" data-id="element-183">
            <li className="flex items-center" data-id="element-184">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3" data-id="element-185"></span>
              rilassarsi
            </li>
            <li className="flex items-center" data-id="element-186">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3" data-id="element-187"></span>
              concentrarsi meglio
            </li>
            <li className="flex items-center" data-id="element-188">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3" data-id="element-189"></span>
              gestire le emozioni
            </li>
            <li className="flex items-center" data-id="element-190">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3" data-id="element-191"></span>
              canalizzare l'energia in modo positivo
            </li>
          </ul>
        </div>

        <div className="text-center" data-id="element-192">
          <p className="text-xl text-gray-800 font-semibold mb-2" data-id="element-193">
            Il problema è che trovare attività efficaci richiede tempo.
          </p>
          <p className="text-lg text-gray-600 mb-2" data-id="element-194">
            Bisogna cercare idee online, adattare esercizi per i bambini e
            creare materiali da zero.
          </p>
          <p className="text-lg text-gray-600 font-medium" data-id="element-195">
            E spesso tutto questo diventa complicato.
          </p>
        </div>
      </div>
    </section>;
}